export default __webpack_public_path__ + "static/media/VectorArrow.bc66fab1.svg";